import React from "react"
import { MessageSquare, Package, X } from "lucide-react"
import { motion } from "framer-motion"
import styles from "./PublicationTypeSelector.module.scss"
import ModalOverlay from "../ModalOverlay/ModalOverlay.tsx"
import { useActionGuard } from "../../../hooks/useActionGuard.ts"

const modal = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { delay: 0.1 },
  },
}

interface PublicationTypeSelectorProps {
  onSelectType: (type: "simple" | "product") => void
  onClose: () => void
  userData: {
    image_profile: string
    name: string
    last_name?: string
    razon_social?: string
    type: string
  }
}

export default function PublicationTypeSelector({ onSelectType, onClose, userData }: PublicationTypeSelectorProps) {
  const { guard } = useActionGuard()

  const handleSelectSimple = guard("create_post", () => onSelectType("simple"))
  const handleSelectProduct = guard("create_product", () => onSelectType("product"))

  return (
    <ModalOverlay isOpen={true} onClose={onClose}>
      <motion.div
        variants={modal}
        initial="hidden"
        animate="visible"
        exit="hidden"
        className={styles.modal}
      >
          <div className={styles.content}>
            <div className={styles.header}>
              <h2 className={styles.header_title}>¿Cómo querés publicitarte en Edify?</h2>
              <button type="button" className={styles.header_closeButton} onClick={onClose} aria-label="Cerrar">
                <X size={20} />
              </button>
            </div>
            <p className={styles.subtitle}>Elegí la opción que mejor se adapte a lo que querés mostrar</p>

            <div className={styles.options}>
              <button type="button" className={`${styles.optionButton} ${styles.simple}`} onClick={handleSelectSimple}>
                <div className={`${styles.optionButton_icon} ${styles.simple}`}>
                  <MessageSquare size={24} />
                </div>
                <div className={styles.optionButton_content}>
                  <div className={styles.optionButton_title}>Posteo</div>
                  <div className={styles.optionButton_description}>Compartí novedades, trabajos realizados o promociones con la comunidad</div>
                  <div className={styles.optionButton_destination}>Visible en Explorar posteos, servicios y productos</div>
                </div>
              </button>

              <button type="button" className={`${styles.optionButton} ${styles.product}`} onClick={handleSelectProduct}>
                <div className={`${styles.optionButton_icon} ${styles.product}`}>
                  <Package size={24} />
                </div>
                <div className={styles.optionButton_content}>
                  <div className={styles.optionButton_title}>Producto o servicio</div>
                  <div className={styles.optionButton_description}>Mostrá tu producto o servicio con fotos y descripción</div>
                  <div className={styles.optionButton_destination}>Visible en tu perfil y en Explorar posteos, servicios y productos</div>
                </div>
              </button>
            </div>
          </div>
      </motion.div>
    </ModalOverlay>
  )
}
